<div class="container">
    <ng-container *ngIf="isReadMode; else writeMode">
        <span>{{ inputValue }}</span>
    </ng-container>
    <ng-template #writeMode>
        <div class="write-mode-container">
            <mat-form-field appearance="outline">
                <mat-select [formControl]="multiselect" [disabled]="isDisabled" (closed)="onSelectionClosed()">
                    @for (item of dropDownList; track item.value) {
                    <mat-option class="optionHeight" [value]="item.label">{{item.label}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </ng-template>
</div>